import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";

import EnhancedTable from "../../components/common/custom-table/CustomTable";
import { ADMIN_ROLE } from "../../utils/constants";
import AddUser from "../../components/addUser/AddUser";
import { userService } from "../../service";
import { IUser } from "../../interfaces";
import SubTopBar from "../../components/template/SubTopBar";
import Loader from "../../components/Loader";
import { Box } from "@mui/material";

const Admins = () => {
  const [userCreation, setUserCreation] = useState(false);
  const [usersData, setUsersData] = useState<IUser[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    setLoading(true);
    const res = await userService.getAdmins();
    setLoading(false);
    if (!res.status || !res.data) {
      console.log(res.message);
      return;
    }

    setUsersData(res.data);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      {userCreation ? (
        <AddUser
          cancel={() => {
            setUserCreation(false);
          }}
          refresh={() => {
            fetchUsers();
          }}
          title="Admin"
          role={ADMIN_ROLE}
        />
      ) : (
        <>
          <SubTopBar
            title="Admins"
            buttonIcon={<AddIcon />}
            buttonText="add admin"
            onButtonClick={() => setUserCreation(true)}
          />
          <Box
            sx={{
              height: "calc(100% - 125px)",
              paddingBottom: "32px",
              paddingRight: "32px",
            }}
          >
            {loading ? (
              <Loader isResponsive />
            ) : (
              <>
                {usersData?.length ? (
                  <EnhancedTable
                    tableData={usersData}
                    refresh={() => {
                      fetchUsers();
                    }}
                    role={ADMIN_ROLE}
                  />
                ) : (
                  <Typography>No data</Typography>
                )}
              </>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default Admins;
